module.exports = __webpack_public_path__ + "static/media/Einstein.642e6ef9.png";